/* eslint-disable camelcase */
import axios from '@axios'
export const state = {
  trashes: [],
  currentPage: 1,
  perPage: 15,
  totalPages: 1,
  totalRecords: 0,
}

export const getters = {
  allTrashes: (state) => state.trashes,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalCampaign: (state) => state.totalCampaign,
  totalRecords: (state) => state.totalRecords,

}

export const mutations = {
  GET_TRASHES: (state, data) => {
    if (!data) return false
    state.trashes = Array.isArray(data.campaigns) ? data.campaigns : []
    state.currentPage =
      typeof data.page === 'number' ? data.page : state.currentPage
    state.perPage =
      typeof data.perPage === 'number' ? data.perPage : state.perPage
    state.totalPage =
      typeof data.totalPages === 'number' ? data.totalPages : state.totalPage
    state.totalRecords =
      typeof data.totalRecords === 'number'
        ? data.totalRecords
        : state.totalRecords
  },
  RESTORE_TRASH: (state, restored) => {
    state.trashes = state.trashes.filter((t) => t.id !== restored.id)
  },
  REMOVE_TRASH: (state, trash) => {
    state.trashes = state.trashes.filter((r) => r.id !== trash.id)
  },
}

export const actions = {
  async getTrashes({ commit, dispatch }, params = {}) {
    dispatch('layout/changeLoading', true, { root: true })
    params = { ...params, ...{ type: 'trash' } }
    await axios
      .get(`/sms/campaigns`, { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          let data = resp.data
          commit('GET_TRASHES', data)
          dispatch('layout/changeLoading', false, { root: true })
        }
      })
      .catch(() => {
        commit('GET_TRASH', null)
      })
      .finally(() => {
        dispatch('layout/changeLoading', false, { root: true })
      })
  },

  async getTrash({ dispatch }, id) {
    dispatch('layout/changeLoading', true, { root: true })
    return axios.get(`/sms/campaigns/${id}`)
  },

  async decryptCampaign({ dispatch }, campaign) {
    dispatch('layout/changeLoading', true, { root: true })
    return axios.get(`/sms/campaigns/${campaign.id}/decode`)
  },
  async removeTrash({ commit }, trash) {
    await axios
      .delete(`/sms/campaigns/${trash.id}`)
      .then((resp) => {
        if (resp.status === 204) {
          commit('REMOVE_TRASH', trash)
        }
      })
  },
  async restoreTrash({ commit, dispatch }, trash) {
    dispatch('layout/changeLoading', true, { root: true })
    axios.patch(`/sms/campaigns/${trash.id}`)
      .then((resp) => {
        if (resp.status === 200) {
          let restored = resp.data
          commit('RESTORE_TRASH', restored)
          dispatch('layout/changeLoading', false, { root: true })
        }
      })
  },

}